import instance from 'services/api';
import { toast } from 'react-toastify';
import {
  GET_COUPONS_POS,
  SET_COUPONS_POS,
  SET_LOADING_POS,
} from 'redux/actions/types';

const toastError = (err) => {
  const message = err?.response?.data?.message;
  toast.error(message?.message || message || '');
};

export const getCouponsPOS =
  ({ businessUuid, promotionUuid }) =>
  (dispatch) => {
    dispatch({ type: SET_LOADING_POS, payload: true });
    return instance
      .get(`/cloud-pos/promotion/coupons`, {
        params: { businessUuid, promotionUuid },
      })
      .then((response) => {
        const items = response?.data?.data?.items || [];
        dispatch({ type: GET_COUPONS_POS, payload: items });
        dispatch({ type: SET_LOADING_POS, payload: false });
        return items;
      })
      .catch((err) => {
        dispatch({ type: SET_LOADING_POS, payload: false });
        return Promise.reject(err);
      });
  };

export const createCouponPOS = (body) => (dispatch, getState) => {
  const coupons = getState().pos.coupons || [];
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .post(`/cloud-pos/promotion/coupons`, body)
    .then((response) => {
      const data = response?.data?.data;
      dispatch({ type: SET_COUPONS_POS, payload: [...coupons, data] });
      dispatch({ type: SET_LOADING_POS, payload: false });
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      toastError(err);
      return Promise.reject(err);
    });
};

export const updateCouponPOS =
  ({ uuid, body }) =>
  (dispatch, getState) => {
    const coupons = getState().pos.coupons || [];
    dispatch({ type: SET_LOADING_POS, payload: true });
    return instance
      .patch(`/cloud-pos/promotion/coupons/${uuid}`, body)
      .then((response) => {
        const data = response?.data?.data;
        const updated = coupons.map((coupon) =>
          coupon?.uuid === uuid ? data : coupon
        );
        dispatch({ type: SET_COUPONS_POS, payload: updated });
        dispatch({ type: SET_LOADING_POS, payload: false });
        return data;
      })
      .catch((err) => {
        dispatch({ type: SET_LOADING_POS, payload: false });
        toastError(err);
        return Promise.reject(err);
      });
  };

export const deleteCouponPOS = (uuid) => (dispatch, getState) => {
  const coupons = getState().pos.coupons || [];
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .delete(`/cloud-pos/promotion/coupons/${uuid}`)
    .then(() => {
      const filtered = coupons.filter((coupon) => coupon?.uuid !== uuid);
      dispatch({ type: SET_COUPONS_POS, payload: filtered });
      dispatch({ type: SET_LOADING_POS, payload: false });
      return filtered;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      toastError(err);
      return Promise.reject(err);
    });
};

export const clearCouponsPOS = () => (dispatch) =>
  dispatch({ type: SET_COUPONS_POS, payload: [] });
